import { render, staticRenderFns } from "./DocumentListView.vue?vue&type=template&id=4cf8c935&"
import script from "./DocumentListView.vue?vue&type=script&lang=ts&"
export * from "./DocumentListView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
